module.exports = __webpack_public_path__ + "img/tmx_store_huawei_jozsef_korut_1024.2f29e356.jpg";